(() => {
  const groups = [
    ['speaker', 'luidspreker', 'topkast', 'pa speaker', 'monitor'],
    ['subwoofer', 'sub', 'baskast', 'bas speaker'],
    ['microfoon', 'mic', 'zangmicrofoon', 'draadloze microfoon'],
    ['movinghead', 'moving head', 'lamp', 'par', 'podiumlicht', 'lichteffect'],
    ['dj set', 'cdj', 'draaitafel', 'mengpaneel', 'dj gear'],
    ['podium', 'stage', 'stagedex', 'podiumdeel'],
    ['kabel', 'snoer', 'xlr', 'schuko', 'verlengkabel'],
    ['truss', 'rigging', 'ophangen', 'takel'],
    ['beamer', 'projector', 'scherm', 'video'],
    ['rookmachine', 'hazer', 'mistmachine', 'special effect']
  ];

  const termsFor = (query) => {
    const needle = String(query || '').trim().toLocaleLowerCase('nl');
    if (needle.length < 2) return [];
    const group = groups.find((items) => items.some((item) => item.includes(needle) || needle.includes(item)));
    return group ? group.filter((item) => item !== needle).slice(0, 4) : [];
  };

  const searchUrl = (term) => `/search?type=product&q=${encodeURIComponent(term)}`;
  const render = (target, query, lead) => {
    if (!target) return;
    const terms = termsFor(query);
    target.replaceChildren();
    target.hidden = terms.length === 0;
    if (!terms.length) return;
    const label = document.createElement('span');
    label.textContent = lead;
    target.appendChild(label);
    terms.forEach((term) => {
      const link = document.createElement('a');
      link.href = searchUrl(term);
      link.textContent = term;
      link.dataset.rslrPreservePreviewLink = '';
      target.appendChild(link);
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-rsl-v33-search-form]').forEach((form) => {
      if (form.dataset.rslV33Bound) return;
      form.dataset.rslV33Bound = 'true';
      const input = form.querySelector('[data-rsl-v33-search-input]');
      const suggestions = form.parentElement?.querySelector('[data-rsl-v33-search-suggestions]');
      input?.addEventListener('input', () => render(suggestions, input.value, 'Bedoel je misschien:'));
      render(suggestions, input?.value, 'Zoek ook op:');
    });
    scope.querySelectorAll('[data-rsl-v33-zero-results]').forEach((empty) => {
      render(empty.querySelector('[data-rsl-v33-zero-suggestions]'), empty.dataset.query, 'Probeer ook:');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
